import React from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import SmscConnections from "./SmscConnections";
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import Drawer from '@mui/material/Drawer';
import BearerBoxStoreDrawer from './BearerBoxStoreDrawer';
import { makeStyles } from '@mui/styles';
import RefreshIcon from '@mui/icons-material/Refresh';

const useStyles = makeStyles({
  drawerPaper: {
    width: '80%',
  },
});

function BearerBoxInfo(props) {
  const { status, storeStatus, onRefreshStatus } = props;
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openStoreStatus, setOpenStoreStatus] = React.useState(false);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      { status && (
        <Accordion style={{ marginTop: 10 }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography component="span">
              <Typography component="span" color="textSecondary" gutterBottom>
                <Typography component="span" variant="h5">
                  BEARERBOX
                </Typography>
                {status.ip}
              </Typography>
              <FormControlLabel
                onClick={event => event.stopPropagation()}
                onFocus={event => event.stopPropagation()}
                control={
                  <Button
                    style={{ marginLeft: 20 }}
                    variant="outlined"
                    onClick={handleClick}
                    size="small"
                  >
                    version
                  </Button>
                }
                label=""
              />
              <Typography variant="h5" component="h2">
                {status.timestamp}

                <FormControlLabel
                  label=""
                  onClick={event => event.stopPropagation()}
                  onFocus={event => event.stopPropagation()}
                  control={
                    <Button
                      startIcon={<RefreshIcon />}
                      style={{ marginLeft: 20 }}
                      onClick={onRefreshStatus}
                      size="small"
                      variant="outlined"
                      color="secondary"
                    >
                      Refresh
                    </Button>
                  }
                />
              </Typography>
              <Typography color="textSecondary">{status.status}</Typography>
            </Typography>
          </AccordionSummary>
          <Box style={{ margin: 25 }}>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center"
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center"
              }}
            >
              <div style={{ padding: 20 }}>
                <Typography variant="body2" component="p" color="textSecondary">
                  {status.version.split("\n").map(e => {
                    return (
                      <span key={e}>
                    {e}
                        <br />
                  </span>
                    );
                  })}
                </Typography>
              </div>
            </Popover>
            <Typography color="textSecondary">
              SMS: received {status.sms.received.total} (queued:{" "}
              {status.sms.received.queued}), sent {status.sms.sent.total} (queued:{" "}
              {status.sms.sent.queued}) store size {status.sms.storeSize}
              <Button color="secondary" style={{ marginLeft: 10 }} onClick={() => setOpenStoreStatus(true)}>
                STORE STATUS
              </Button>
              <br />
              SMS: inbound {status.sms.inbound} msg/sec, outbound {status.sms.outbound}{" "}
              msg/sec
            </Typography>
            <br />
            <Typography sx={{ mb: 6 }} color="textSecondary">
              DLR: received {status.dlr.received.total}, sent {status.dlr.sent.total}
              <br />
              DLR: inbound {status.dlr.inbound} msg/sec, outbound {status.dlr.outbound}{" "}
              msg/sec
              <br />
              DLR: queued {status.dlr.queued}, storage {status.dlr.storage}
            </Typography>
            <SmscConnections data={status.smscList} />
          </Box>
        </Accordion>
      )}

      <Drawer
        anchor={"right"}
        open={openStoreStatus}
        onClose={() => setOpenStoreStatus(false)}
        classes={{ paper: classes.drawerPaper }}
      >
        <BearerBoxStoreDrawer
          storeStatus={storeStatus}
          onClose={() => setOpenStoreStatus(false)}
        />
      </Drawer>
    </>
  );
}

export default BearerBoxInfo;
